import React, { Component } from "react";

export default class input extends Component {
  render() {
    return (
      <div className="input-rapper">
        <p
          className="label"
          style={{ opacity: this.props.hidelabel ? "0" : "1" }}
        >
          {this.props.label}
        </p>
        <textarea
          {...this.props}
          autoFocus={this.props.autoFocus ? true : false}
        />
      </div>
    );
  }
}
